export default __webpack_public_path__ + "static/media/mysellpay-logo.d98103a0.svg";